module.exports = __webpack_public_path__ + "static/img/upload.b4cf2f11.png";